module.exports = __webpack_public_path__ + "static/novo-cream-rolls1-974d9dcbf279a0a9b2ab14b7fa597bfe.jpg";